import { type SocketMachineContext } from '../../../network-state-machine-context.ts';

type ErrorContext = Pick<SocketMachineContext, 'transport' | 'debounce' | 'error'>;

export function onEnterError(ctx: ErrorContext) {
  ctx.transport?.dispose();
  ctx.transport = undefined;

  if (ctx.error) {
    ctx.debounce.captureError(ctx.error);
  }
}
